<template>
  <div class="consumer-profile-view">
    <loading v-if="isConsumerProfileFetching || isEmailNotificationsSettingsFetching" />
    <consumer-profile v-else />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ConsumerProfile from '@/app/components/consumer-profile/ConsumerProfile.vue';
import Loading from '@/app/components/Loading';

export default {
  name: 'ConsumerProfileView',
  components: {
    Loading,
    ConsumerProfile
  },
  computed: {
    ...mapGetters('app', [
      'isConsumerProfileFetching',
      'isEmailNotificationsSettingsFetching'
    ])
  },
  async created() {
    await this.fetchConsumerProfile();
    await this.fetchEmailNotificationsSettings();
  },
  methods: {
    ...mapActions('app', [
      'fetchConsumerProfile',
      'fetchEmailNotificationsSettings'
    ])
  }
};
</script>

<style lang="scss" scoped>
@import '@uikit/ui-kit/themes/acronis/src/common/variables';

.consumer-profile-view {
  height: 100%;
  background-color: $av-solid-brand-lightest;
}
</style>
